import { render, staticRenderFns } from "./AppUser.vue?vue&type=template&id=2147a3d4&scoped=true"
import script from "./AppUser.vue?vue&type=script&lang=js"
export * from "./AppUser.vue?vue&type=script&lang=js"
import style0 from "./AppUser.vue?vue&type=style&index=0&id=2147a3d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147a3d4",
  null
  
)

export default component.exports